<template>
  <div>
    <section class="section gradient-banner">
      <div class="shapes-container">
        <div class="shape" data-aos="fade-down-left" data-aos-duration="1500" data-aos-delay="100"></div>
        <div class="shape" data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100"></div>
        <div class="shape" data-aos="fade-up-right" data-aos-duration="1000" data-aos-delay="200"></div>
        <div class="shape" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200"></div>
        <div class="shape" data-aos="fade-down-left" data-aos-duration="1000" data-aos-delay="100"></div>
        <div class="shape" data-aos="fade-down-left" data-aos-duration="1000" data-aos-delay="100"></div>
        <div class="shape" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300"></div>
        <div class="shape" data-aos="fade-down-right" data-aos-duration="500" data-aos-delay="200"></div>
        <div class="shape" data-aos="fade-down-right" data-aos-duration="500" data-aos-delay="100"></div>
        <div class="shape" data-aos="zoom-out" data-aos-duration="2000" data-aos-delay="500"></div>
        <div class="shape" data-aos="fade-up-right" data-aos-duration="500" data-aos-delay="200"></div>
        <div class="shape" data-aos="fade-down-left" data-aos-duration="500" data-aos-delay="100"></div>
        <div class="shape" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0"></div>
        <div class="shape" data-aos="fade-down" data-aos-duration="500" data-aos-delay="0"></div>
        <div class="shape" data-aos="fade-up-right" data-aos-duration="500" data-aos-delay="100"></div>
        <div class="shape" data-aos="fade-down-left" data-aos-duration="500" data-aos-delay="0"></div>
      </div>

      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order-2 order-md-1 text-center text-md-left">
            <h1 class="text-white font-weight-bold mb-4">
              Bem vindo ao IBCGP! Seu gestor parceiro.
            </h1>

            <p class="text-white mb-4 hero-lead">
              O IBCGP apoia municípios com sistemas em operação na gestão tributária,
              em processos seletivos e na capacitação de servidores. A afiliação ao instituto é gratuita.
            </p>

            <div class="hero-ctas mb-4">
              <a :href="links.contatoAfiliacao" class="ibcgp-btn-solid pulse-button d-inline-block mr-md-2 mb-2 mb-md-0">
                Afiliar meu município
              </a>
              <a href="#solucoes" class="ibcgp-btn-ghost-light d-inline-block mb-2 mb-md-0">
                Conhecer soluções
              </a>
            </div>
          </div>

          <div class="col-md-6 text-center order-1 order-md-2">
            <img
              class="img-fluid"
              src="../../../assets/images/ibcgp/banner.png"
              alt="Representação visual das soluções digitais do IBCGP para municípios"
            >
          </div>
        </div>
      </div>
    </section>

    <section class="section pt-0 position-relative pull-top hero-quick" style="padding: 30px 0 !important">
      <div class="container" style="max-width: 960px !important;">
        <div class="rounded p-4 bg-white quick-links-card ibcgp-card-elevated" style="padding: 1rem 1.25rem !important">
          <home-spotlight-carousel/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import links from '../../../consts/links.js'
import HomeSpotlightCarousel from './HomeSpotlightCarousel.vue'

export default {
  name: 'HeroSection',
  components: {
    'home-spotlight-carousel': HomeSpotlightCarousel
  },
  data () {
    return { links }
  }
}
</script>

<style scoped>
.hero-lead {
  font-size: 1.05rem;
  line-height: 1.55;
  opacity: 0.96;
}

.pulse-button {
  animation: pulse-ibcgp 2.2s ease-in-out infinite;
}

@keyframes pulse-ibcgp {
  0% {
    box-shadow: 0 4px 14px rgba(46, 126, 237, 0.45);
  }
  50% {
    box-shadow: 0 4px 22px rgba(46, 126, 237, 0.65);
  }
  100% {
    box-shadow: 0 4px 14px rgba(46, 126, 237, 0.45);
  }
}

.hero-quick .quick-links-card {
  border: 1px solid rgba(2, 34, 91, 0.06);
}
</style>
